/* Chutak Binak — "The Thread" motion engine.
   Vanilla JS, < 8KB. Animates transform/opacity/dashoffset only. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Crochet loader (once per session) ---------- */
  var loader = document.getElementById('cb-loader');
  if (loader) {
    if (reduced || sessionStorage.getItem('cb-loaded')) {
      loader.classList.add('cb-loader--done');
    } else {
      loader.classList.add('cb-loader--run');
      setTimeout(function () {
        loader.classList.add('cb-loader--done');
        try { sessionStorage.setItem('cb-loaded', '1'); } catch (e) {}
      }, 1700);
    }
    loader.addEventListener('transitionend', function () { loader.remove(); });
    setTimeout(function () { if (loader.parentNode) loader.remove(); }, 3000);
  }

  /* ---------- Stitch reveals ---------- */
  var targets = document.querySelectorAll('[data-stitch], .selvedge, .stitch-rule');
  if ('IntersectionObserver' in window && !reduced) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) {
          en.target.classList.add('is-stitched');
          io.unobserve(en.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    targets.forEach(function (t) { io.observe(t); });
  } else {
    targets.forEach(function (t) { t.classList.add('is-stitched'); });
  }

  /* Stagger siblings sharing a parent */
  document.querySelectorAll('[data-stitch-group]').forEach(function (group) {
    Array.prototype.forEach.call(group.children, function (child, i) {
      child.style.setProperty('--stitch-delay', (i * 110) + 'ms');
    });
  });

  /* ---------- Traveling thread: drawn by scroll progress ---------- */
  var path = document.getElementById('thread-path');
  if (path && !reduced) {
    var len = path.getTotalLength();
    path.style.strokeDasharray = len;
    path.style.strokeDashoffset = len;
    var ticking = false;
    var draw = function () {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      var p = max > 0 ? Math.min(1, window.scrollY / max) : 1;
      path.style.strokeDashoffset = String(len * (1 - p));
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(draw); }
    }, { passive: true });
    draw();
  }

  /* ---------- Mobile nav ---------- */
  var burger = document.querySelector('.header-burger');
  var mnav = document.getElementById('mobile-nav');
  if (burger && mnav) {
    burger.addEventListener('click', function () {
      var open = mnav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---------- Testimonial rotation (with pause control) ---------- */
  var stage = document.querySelector('.voices__stage');
  if (stage) {
    var voices = stage.querySelectorAll('.voice');
    var dots = document.querySelectorAll('.voices__dots button');
    var pauseBtn = document.querySelector('[data-voices-pause]');
    var idx = 0, timer = null, paused = reduced;

    var show = function (n) {
      idx = n % voices.length;
      voices.forEach(function (v, i) { v.classList.toggle('is-active', i === idx); });
      dots.forEach(function (d, i) { d.setAttribute('aria-selected', i === idx ? 'true' : 'false'); });
    };
    var stop = function () {
      if (timer) { clearInterval(timer); timer = null; }
    };
    var start = function () {
      stop();
      if (!paused && voices.length > 1) timer = setInterval(function () { show(idx + 1); }, 6500);
    };

    dots.forEach(function (d, i) {
      d.addEventListener('click', function () { show(i); start(); });
    });

    if (pauseBtn) {
      var setPauseUI = function () {
        pauseBtn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        pauseBtn.setAttribute('aria-label', paused ? 'Resume testimonial rotation' : 'Pause testimonial rotation');
      };
      pauseBtn.addEventListener('click', function () {
        paused = !paused;
        setPauseUI();
        start();
      });
      setPauseUI();
    }

    /* Pause while the user is reading/hovering or has focus inside; resume on leave unless explicitly paused */
    var stageRoot = document.querySelector('.voices');
    if (stageRoot) {
      stageRoot.addEventListener('mouseenter', stop);
      stageRoot.addEventListener('mouseleave', start);
      stageRoot.addEventListener('focusin', stop);
      stageRoot.addEventListener('focusout', start);
    }

    show(0); start();
  }

  /* ---------- Product: variant price + qty steppers ---------- */
  var form = document.querySelector('[data-product-form]');
  if (form) {
    var json = document.getElementById('product-json');
    var variants = json ? JSON.parse(json.textContent) : [];
    var priceEl = document.querySelector('[data-price]');
    var idInput = form.querySelector('input[name="id"]');
    var atc = form.querySelector('[data-atc]');
    var fmt = function (cents) {
      return (form.dataset.currency || 'Rs. ') + (cents / 100).toLocaleString('en-IN', { minimumFractionDigits: 2 });
    };
    form.addEventListener('change', function () {
      var picked = [];
      form.querySelectorAll('fieldset').forEach(function (fs) {
        var c = fs.querySelector('input:checked');
        if (c) picked.push(c.value);
      });
      var match = variants.find(function (v) {
        return picked.every(function (val, i) { return v.options[i] === val; });
      });
      if (match && idInput) {
        idInput.value = match.id;
        if (priceEl) priceEl.textContent = fmt(match.price);
        if (atc) {
          atc.disabled = !match.available;
          atc.textContent = match.available ? atc.dataset.add : atc.dataset.soldout;
        }
      }
    });
  }

  /* ---------- Quantity steppers: local-only (product page) or AJAX cart update (cart page) ---------- */
  var updateCartLine = function (box, quantity) {
    var input = box.querySelector('input');
    var key = box.dataset.key;
    if (!key) return; /* not a cart line — just a local stepper, nothing to sync */

    var cartSection = document.querySelector('[data-cart-section]');
    var sectionId = cartSection ? cartSection.dataset.cartSection : null;

    box.dataset.loading = '1';
    box.style.opacity = '.5';

    var payload = { id: key, quantity: quantity };
    if (sectionId) payload.sections = sectionId;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart update failed');
        return r.json();
      })
      .then(function (data) {
        if (sectionId && data.sections && data.sections[sectionId] && cartSection) {
          var doc = new DOMParser().parseFromString(data.sections[sectionId], 'text/html');
          var fresh = doc.querySelector('[data-cart-section]');
          if (fresh) {
            cartSection.replaceWith(fresh);
            bindCartQty(fresh);
          }
        }
        var count = document.querySelector('.cart-count');
        if (count) {
          if (data.item_count > 0) { count.textContent = data.item_count; count.style.display = ''; }
          else { count.style.display = 'none'; }
        }
      })
      .catch(function () {
        if (input && input.form) input.form.submit();
      })
      .finally(function () {
        box.dataset.loading = '';
        box.style.opacity = '';
      });
  };

  var bindCartQty = function (root) {
    root.querySelectorAll('[data-qty]').forEach(function (box) {
      if (box.dataset.bound) return;
      box.dataset.bound = '1';
      var input = box.querySelector('input');
      box.querySelectorAll('button').forEach(function (b) {
        b.addEventListener('click', function () {
          if (box.dataset.loading) return;
          var min = b.dataset.min === '0' ? 0 : 1;
          var v = Math.max(min, parseInt(input.value || '1', 10) + (b.dataset.dir === 'up' ? 1 : -1));
          input.value = v;
          updateCartLine(box, v);
        });
      });
    });
  };
  bindCartQty(document);
})();